<template>
  <div :class="{ wrapperExtra: true, wrapperRestyle: true }">
    <template v-if="props.options.length === 0">
      <div style="height: 100%; display: flex; justify-content: center; align-items: center">Нет доступных</div>
    </template>

    <template v-if="props.options.length !== 0">
      <el-select value-key="id" style="display: none" :model-value="props.extraPackaging" multiple collapse-tags> </el-select>
      <el-checkbox
        v-for="option in props.options"
        :class="{ disabled: disabledForm }"
        :key="option.id"
        :disabled="disabledForm || dataForm.requestPendingForPackaging || option.isLocked"
        :model-value="option.isSelected"
        @change="handleChangeCheckbox(option)"
        class="checkboxCustom"
        :value="option"
        :label="option.title"
        border
      />
    </template>
  </div>
</template>

<script setup>
import { useNewDataFormCargoPickUpStore } from '@/stores/newFormCargoPickUp';
import { computed } from 'vue';

const props = defineProps({
  extraPackaging: Array,
  disabledCustom: Boolean,
  options: Array,
});

const disabledForm = computed(() => !(((dataForm.getIsValidCylinder || dataForm.getIsValidStandard) && dataForm.cargoInformation.natureOfCargo) || dataForm.cargoInformation.typeOfCargo.id === 3));
const emit = defineEmits(['update:extraPackaging']);

const dataForm = useNewDataFormCargoPickUpStore();

const findSelectedIndex = (option) => {
  return props.extraPackaging?.findIndex((el) => el.id === option.id);
};

const checkRequiredSelected = (fetched, selected) => {
  const fetchHasRequired = Boolean(fetched.find((el) => el.isRequired));
  if (fetchHasRequired) {
    const selectedHasRequired = Boolean(selected.find((el) => el.isRequired));
    if (!selectedHasRequired) {
      return false;
    }
  }
  return true;
};

const handleChangeCheckbox = (value) => {
  const indexOfOption = findSelectedIndex(value);
  let newExtraPackaging;
  if (indexOfOption !== -1) {
    newExtraPackaging = props.extraPackaging.filter((_packaging, id) => id !== indexOfOption);
  } else {
    newExtraPackaging = [...props.extraPackaging, value];
  }

  if (!checkRequiredSelected(dataForm.fetchedExtraPackaging, newExtraPackaging)) {
    newExtraPackaging = [];
  }

  emit('update:extraPackaging', newExtraPackaging);
};
</script>

<style lang="scss" scoped>
.wrapperExtra {
  display: flex;
  flex-direction: column;

  overflow-y: auto;

  width: 280px;
  height: 170px;
  border-radius: 8px;
  border: 1px solid #caced9;

  .checkboxCustom {
    padding-block: 5px;
    width: 100%;
    border-radius: 0px;
    border-width: 0px;
    border-bottom-width: 1px;
    margin: 0;
  }
}

.disabled {
  user-select: none;
  cursor: not-allowed;
}
</style>

<style>
@media (max-width: 1280px) {
  .wrapperRestyle {
    .el-checkbox__label {
      font-size: 12px;
    }
  }
}
</style>
